// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ConditionalWrapperChildren = React.PropsWithChildren<any> | null;

export const ConditionalWrapper = ({
	condition,
	wrapper,
	children,
}: {
	condition: boolean;
	wrapper: (children: ConditionalWrapperChildren) => ConditionalWrapperChildren;
	children: ConditionalWrapperChildren;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
}): any => (condition ? wrapper(children) : children);
